import { useState } from "react";

import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import SubscribeModal from "pages/UserInfo/sections/UserHero/SubscribeModal";

import { useTranslation } from "react-i18next";

import bgImage from "assets/images/bg-user-info.jpg";

function ThirdHero() {
  const { t } = useTranslation();
  const [isSubModalOpen, setIsSubModalOpen] = useState(false);
  const warningKeys = ["stabilityWarning", "shareWarning", "converterWarning"];

  return (
    <MKBox
      minHeight="52vh"
      width="100%"
      sx={({ breakpoints }) => ({
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "grid",
        placeItems: "center",
        paddingTop: "5rem",
        paddingBottom: "5rem",
        [breakpoints.down("md")]: {
          paddingTop: "6rem",
          paddingBottom: "6rem",
        },
      })}
    >
      <Container>
        <Grid container spacing={3} alignItems="center" justifyContent="center">
          <Grid
            item
            xs={12}
            md={6}
            sx={{
              textAlign: "center",
              mt: { xs: 2, md: 0 },
            }}
          >
            <MKTypography variant="h4" color="white" fontWeight="bold">
              {t("clients.third.hero.title")}
            </MKTypography>

            <MKTypography variant="body2" color="white" opacity={0.8} mt={1}>
              {t("clients.third.hero.apps")}
            </MKTypography>
            <MKBox mt={2} display="flex" flexWrap="wrap" justifyContent="center" gap={1.5}>
              <MKButton
                variant="outlined"
                color="white"
                size="small"
                sx={{
                  fontSize: "0.8rem",
                  padding: "0 12px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                }}
                onClick={() => setIsSubModalOpen(true)}
              >
                {t("clients.third.hero.subscribeButton")}
              </MKButton>
            </MKBox>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{
              mt: { xs: 4, md: 0 },
            }}
          >
            <MKTypography variant="h6" color="white" fontWeight="bold">
              {t("clients.third.hero.usage.title")}
            </MKTypography>

            {warningKeys.map((warningKey, index) => (
              <MKTypography
                key={warningKey}
                variant="body2"
                color="error"
                fontWeight="bold"
                mt={index === 0 ? 1.2 : 0.75}
                lineHeight={1.55}
                sx={{ display: "block" }}
              >
                {index + 1}. {t(`clients.third.hero.usage.${warningKey}`)}
              </MKTypography>
            ))}
          </Grid>
        </Grid>
      </Container>
      <SubscribeModal open={isSubModalOpen} onClose={() => setIsSubModalOpen(false)} />
    </MKBox>
  );
}

export default ThirdHero;
